/******************************************************************************
 *
 * FILE:
 * src/modules/wms/workspace/approval/services/approvalWorkspaceService.js
 *
 * MODULE:
 * Work Management System (WMS)
 *
 * FEATURE:
 * Approval Workspace
 *
 * DESCRIPTION:
 * Service layer for Approval Workspace.
 *
 ******************************************************************************/

import axiosClient from "../../../../../api/axiosClient";

// ============================================================================
// APPROVAL WORKSPACE SERVICE
// ============================================================================

const approvalWorkspaceService = {

    // ==========================================================
    // LOAD APPROVAL INBOX
    // ==========================================================

    async getApprovalWorkspace(filters = {}) {

        const response = await axiosClient.get(

            "/api/wms/works/approval-workspace",

            {
                params: filters,
            }

        );

        return response.data.data;

    },

    // ==========================================================
    // LOAD APPROVAL WORKSPACE DETAILS
    // ==========================================================

    async getApprovalWorkspaceDetails(workId) {

        const response = await axiosClient.get(

            `/api/wms/works/${workId}/approval-workspace`

        );

        return response.data.data;

    },

    // ==========================================================
    // APPROVE WORK
    // ==========================================================

    async approveWork(
        workId,
        approvalComments = ""
    ) {

        const response = await axiosClient.post(

            `/api/wms/works/${workId}/approve`,

            {
                approval_comments: approvalComments,
            }

        );

        return response.data.data;

    },

    // ==========================================================
    // REJECT WORK
    // ==========================================================

    async rejectWork(
        workId,
        rejectionReason = ""
    ) {

        const response = await axiosClient.post(

            `/api/wms/works/${workId}/reject`,

            {
                rejection_reason: rejectionReason,
            }

        );

        return response.data.data;

    },

    // ==========================================================
    // SEND BACK WORK
    // ==========================================================

    async sendBackWork(
        workId,
        sendBackComments = ""
    ) {

        const response = await axiosClient.post(

            `/api/wms/works/${workId}/send-back`,

            {
                send_back_comments: sendBackComments,
            }

        );

        return response.data.data;

    },

    // ==========================================================
    // ADD COMMENT
    // ==========================================================

    async addComment(
        workId,
        commentText
    ) {

        const response = await axiosClient.post(

            `/api/wms/works/${workId}/comments`,

            {
                comment_text: commentText
            }

        );

        return response.data.data;

    },

};



export default approvalWorkspaceService;